import { QueryConfig } from "store/utils/query-config";

export const customerPaymentReceiptsDefaultQueryConfig: QueryConfig = {
  query: {},
  options: {
    sortBy: ["addedAt"],
  },
};

export function customerPaymentReceiptsQueryForBooking(
  bookingId: string
): QueryConfig {
  return {
    query: { bookingId },
    options: { sortBy: ["addedAt"] },
  };
}

export function customerPaymentReceiptsQueryForBookings(
  bookingIds: string[]
): QueryConfig {
  return {
    query: { bookingId: { $in: bookingIds } },
    options: { sortBy: ["-addedAt"] },
  };
}
